<template>
    <MediaTypes />
  <section class="product-documentation-filters">
    <div class="product-documentation-filters__dropdowns">
      <DropDown
        v-if="productStore.selectedType.length > 0"
        id="productFamilies"
        :options="productStore.productFamilies"
        :title="productStore.translations?.productFamily"
        v-model="productStore.selectedProduct"
        @onSelect="onProductChange($event)"
      />
      <DropDown
        v-if="productStore.selectedProduct.length > 0"
        id="languages"
        :options="productStore.languages"
        :title="productStore.translations?.language"
        v-model="productStore.selectedLanguage"
        @onSelect="onLanguageChange($event)"
        @search="performSearch()"
      />
      <ProductDocumentation
        v-if="productStore.selectedProduct.length > 0"
        :title="productStore.translations?.serialnumber"
      />
    </div>
  </section>
</template>

<script setup>
import MediaTypes from "./MediaTypes.vue";
import DropDown from "./DropDown.vue";
import ProductDocumentation from "./ProductDocumentation.vue";
import { useProductStore } from '../store/store';

const productStore = useProductStore();

const onProductChange = (option) => {
  productStore.selectedProduct = option.value;
}

const onLanguageChange = (option) => {
  productStore.selectedLanguage = option.key;
  productStore.selectedLanguageCode = option.value;
}

const performSearch = () => {
  productStore.performSearch();
}

const emit = defineEmits(['selectedProduct']);
</script>